// Piezas compartidas por los detalles de visita con el layout v2
// (PreSaleVisitDetail y RentVisitDetail).

// '02/10/2026' (dd/mm/yyyy) -> '2026-10-02' para <input type="date">.
export const toInputDate = (value?: string): string => {
  const match = value?.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return '';
  const [, day, month, year] = match;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

// '7:00 AM' / '13:00' / '1:30 pm' -> minutos desde medianoche (undefined si no
// se puede leer).
export const timeToMinutes = (value?: string): number | undefined => {
  const match = value?.match(/(\d{1,2}):(\d{2})\s*([ap])?\.?m?\.?/i);
  if (!match) return undefined;
  let hours = Number(match[1]);
  const minutes = Number(match[2]);
  const meridiem = match[3]?.toLowerCase();
  if (meridiem === 'p' && hours < 12) hours += 12;
  if (meridiem === 'a' && hours === 12) hours = 0;
  return hours * 60 + minutes;
};

export const Field = ({
  label,
  children,
}: {
  label: string;
  children: any;
}) => (
  <div className="vd-field">
    <span className="vd-field__label">{label}</span>
    <span className="vd-field__value">{children || '—'}</span>
  </div>
);

export const Section = ({
  icon,
  tone,
  title,
  children,
}: {
  icon: JSX.Element;
  tone: 'blue' | 'green' | 'orange';
  title: string;
  children: any;
}) => (
  <section className="vd-card">
    <header className="vd-card__header">
      <span className={`vd-icon vd-icon--${tone}`}>{icon}</span>
      <h2 className="vd-card__title">{title}</h2>
    </header>
    {children}
  </section>
);
